// © Microsoft Corporation. All rights reserved.

import { getSubscriptionsForPublisher } from "@msnews/subscription-sdk-wrapper";
import { getXPayToken, User } from "@msnews/social-data-service";

export async function hasPremiumSubscription (me: User, publisherId: string): Promise<boolean> {
    return getSubscriptionsForPublisher({
        publisherId: publisherId,
        authToken: await getXPayToken(me.id)
    }).then(response => {
        if (response.status && response.data && response.data.find(s => s.subscriptionType === "Premium")) {
            return true;
        }
        return false;
    }).catch(() => {
        return false;
    });
}
